import { Star } from "./Logo";
import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      className="overflow-hidden border-y py-5"
      style={{ borderColor: "var(--line)", background: "var(--surface-secondary)" }}
      data-testid="marquee-section"
    >
      <div className="marquee-track items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8 whitespace-nowrap">
            <span className="font-serif-display text-2xl sm:text-3xl font-medium italic" style={{ color: "var(--on-surface)" }}>
              {item}
            </span>
            <Star size={15} />
          </span>
        ))}
      </div>
    </div>
  );
}
